import React, { useState } from 'react'
import { graphql } from 'gatsby'
import Layout from '../components/common/Layout'
import Course from '../components/academy/Course'

const CoursePage = ({ data }) => {
  const { course, lessons } = data
  
  if (!course) {
    return (
      <Layout title="Course Not Found">
        <main><p>Course not found</p></main>
      </Layout>
    )
  }
  
  const lessonSlugs = course.frontmatter.lessons || []
  
  // Match lesson slugs with actual lesson data
  // Lessons are in the same directory as the course, so their slugs will be like /academy/atlas-101/introduction/
  const matchedLessons = lessonSlugs.map(slug => {
    const lesson = lessons.nodes.find(l => {
      // Check multiple ways to match:
      // 1. Frontmatter slug matches exactly
      // 2. Slug path ends with the lesson slug
      // 3. Slug path contains the lesson slug in the right position
      const frontmatterSlug = l.frontmatter.slug
      const slugPath = l.fields.slug || ''
      const courseSlugPath = course.fields.slug || ''
      
      // Extract course directory from course slug (e.g., /academy/atlas-101/)
      const expectedLessonPath = `${courseSlugPath}${slug}/`
      
      return frontmatterSlug === slug || 
             slugPath === expectedLessonPath ||
             slugPath.endsWith(`/${slug}/`)
    })
    
    if (!lesson) {
      console.warn(`Could not find lesson with slug: ${slug}`)
      return null
    }
    
    return {
      _id: lesson.id,
      id: lesson.id,
      title: lesson.frontmatter.title,
      slug: { current: lesson.frontmatter.slug || slug },
      duration: lesson.frontmatter.duration || 0,
      description: lesson.frontmatter.description
    }
  }).filter(Boolean)
  
  const courseData = {
    title: course.frontmatter.title,
    slug: { current: course.frontmatter.slug },
    description: course.frontmatter.description,
    level: course.frontmatter.level,
    longDescription: course.frontmatter.longDescription,
    featuredImage: { asset: { url: course.frontmatter.featuredImage || 'https://atlas.co/images/academy-og.png' } },
    lessons: matchedLessons
  }
  
  const featuredImageUrl = courseData.featuredImage?.asset?.url || 'https://atlas.co/images/academy-og.png'
  
  return (
    <Layout
      meta={{
        description: courseData.description ||
          'Atlas Academy is a collection of courses to help you learn spatial data science and location intelligence. Get started with Atlas Academy today.',
        title: courseData.title || 'Atlas Academy',
        type: 'website',
        absoluteImageUrl: featuredImageUrl
      }}
      title={courseData.title || 'Atlas Academy'}
    >
      <main>
        <Course courseData={courseData} />
      </main>
    </Layout>
  )
}

export default CoursePage

export const query = graphql`
  query ($id: String!) {
    course: markdownRemark(id: { eq: $id }) {
      id
      fields {
        slug
      }
      frontmatter {
        title
        slug
        description
        level
        longDescription
        featuredImage
        lessons
      }
    }
    lessons: allMarkdownRemark(
      filter: { 
        fileAbsolutePath: { regex: "/academy/" }
        frontmatter: { template: { eq: "LessonPage" } }
      }
    ) {
      nodes {
        id
        fields {
          slug
        }
        frontmatter {
          title
          slug
          duration
          description
        }
      }
    }
  }
`
